import { render } from "./projectEdit.vue?vue&type=template&id=5c5132fa&scoped=true"
import script from "./projectEdit.vue?vue&type=script&lang=js"
export * from "./projectEdit.vue?vue&type=script&lang=js"

import "./projectEdit.vue?vue&type=style&index=0&id=5c5132fa&scoped=true&lang=css"

import exportComponent from "G:\\zhongfu\\web\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5c5132fa"]])

export default __exports__